export class CompositeSpine extends Phaser.GameObjects.Container {
  constructor({ scene, position = { x: 0, y: 0 }, scale, keys = [] }) {
    super(scene, position.x, position.y);
    this.scene = scene;
    scene.add.existing(this);

    this.scale = scale;
    this.keys = keys;
    this.setPosition(position.x, position.y);

    this.spines = [];
    for (const key of this.keys) {
      const spine = this.scene.add.spine(0, 0, key);
      spine.name = key;
      this.spines.push(spine);
      this.add(spine);
    }
  }

  playAll(animationId, loop = false, ignoreIfPlaying = false) {
    for (const spine of this.spines) {
      spine.play(animationId, loop, ignoreIfPlaying);
    }
  }

  playSpine(spineId, animationId, loop = false, ignoreIfPlaying = false) {
    const spine = this.getSpine(spineId);
    if (spine) {
      spine.play(animationId, loop, ignoreIfPlaying);
    }
  }

  getSpine(spineId) {
    return this.spines.find((s) => s.name === spineId);
  }

  moveSpineToTop(spineId) {
    const spine = this.getSpine(spineId);
    if (spine) this.bringToTop(spine);
  }

  removeAllListeners() {}

  destroy() {
    this.spines = null;
    super.destroy();
  }
}
